import { Tab, Tabs, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react';
import GeneralModal from '../../Common/Modal/GeneralModal/GeneralModal';
import DropDown from '../../Common/DropDown';
import { TextField } from '../../Common/Textfield';
import DigitalStampDenomination from './DigitalStampDenomination';
import PrimaryButton from '../../Common/Button/PrimaryButton';
import { nanoid } from 'nanoid';
import {
  DigitalStampDemominationOrderRequest,
  DigitalStampOrderDetails,
  DigitalStampOrderGetState,
  FetchLocationFromPincode,
  getArticleCodes,
  GetProfilePic
} from '../../../Services/APIConfig';
import { validateName, validatePincode } from '../../../utils/util';
import { useDispatch } from 'react-redux';
import './DigitalStampPopup.css';
import { updateSuccessStatus } from '../../../Store/DashboardSlice/DashboardSlice';
import { POSTAL_CODE } from '../../../constants/regex';
import Loading from '../LoaderComponent/Loader';
import CustomToast from '../CustomToast';

export default function DigitalStampOrder({ open, onClose }) {
  const { showToast } = CustomToast();
  const isMobile = useMediaQuery('(max-width:600px)');
  const [articleCode, setArticleCode] = useState('');
  const dispatch = useDispatch();
  const [tabValue, setTabValue] = React.useState(0);
  const [totalAmountInfo, setTotaAmountInfo] = React.useState({
    subtotalAmount: 0,
    stampMarkupAmount: 0,
    stampGst: 0,
    totalAmount: 0
  });
  const [userData, setUserData] = useState([
    {
      id: nanoid(5),
      denominationAmount: '',
      denominationQty: '',
      denominationValue: ''
    }
  ]);
  const [firstPartyData, setFirstPartyData] = useState({
    name: '',
    address: '',
    state: '',
    dist: '',
    city: '',
    pincode: ''
  });
  const [secondPartyData, setSecondPartyData] = useState({
    name: '',
    address: '',
    state: '',
    dist: '',
    city: '',
    pincode: ''
  });
  const [error, setError] = useState({});

  const [userDataError, setUserDataError] = useState({});

  const [openAlertModel, setOpenAlertModel] = useState(false);
  const [articleCodes, setArticleCodes] = useState([]);
  const [isValidPincode, setIsValidPincode] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [selectState, setSelectState] = useState('');
  const [stampStateValue, setStampStateValue] = useState([]);

  const [userProfileValue, setUserProfileValue] = useState('');

  useEffect(() => {
    fetchUserDetails();
    GetDigitalStampState();
  }, []);
  useEffect(() => {
    if (tabValue === 0 && firstPartyData.pincode.length > 5) {
      fetchLocationByPincode(firstPartyData.pincode, firstPartyData, setFirstPartyData);
    }
    if (tabValue === 1 && secondPartyData.pincode.length > 5) {
      fetchLocationByPincode(secondPartyData.pincode, secondPartyData, setSecondPartyData);
    }
  }, [firstPartyData.pincode, secondPartyData.pincode]);

  const GetDigitalStampState = async () => {
    try {
      const res = await DigitalStampOrderGetState();
      if (res.status === 200) {
        setStampStateValue(res?.data);
      }
    } catch (err) {
      return err;
      // console.log(err);
    }
  };
  const fetchUserDetails = async () => {
    const response = await GetProfilePic();
    if (response?.status === 200) {
      setUserProfileValue(response?.result);
    }
  };
  const fetchLocationByPincode = async (pincode, data, setData) => {
    try {
      const res = await FetchLocationFromPincode(pincode);

      if (res.status === 200) {
        if (tabValue === 0) setIsValidPincode(true);
        let result = res.result;
        let tempOrg = { ...data };
        tempOrg.city = result.subDistrictName;
        tempOrg.dist = result.districtName;
        tempOrg.state = result.stateName;
        setData(tempOrg);
      } else {
        if (tabValue === 0) setIsValidPincode(false);
        setError(prevState => ({
          ...prevState,
          pincode: res?.message
        }));
      }
    } catch (err) {
      setIsValidPincode(false);
      return err;
      //console.log(err);
    }
  };

  const updateGstMarkUpTotal = async (data, signal) => {
    const payload = data.reduce((current, val) => {
      const { denominationAmount, denominationQty } = val;
      return [
        ...current,
        {
          denominationAmount,
          denominationQty
        }
      ];
    }, []);

    if (!userData.find(u => u.denominationValue === '') && userData.find(u => u.denominationQty !== '')) {
      try {
        const response = await DigitalStampDemominationOrderRequest({ orders: payload }, signal);
        const totalAmountInfo = response.data.reduce(
          (accumulator, currentValue) => {
            return {
              subtotalAmount: accumulator.subtotalAmount + currentValue.subtotalAmount,
              totalAmount: accumulator.totalAmount + currentValue.totalAmount,
              stampMarkupAmount: accumulator.stampMarkupAmount + currentValue.stampMarkupAmount,
              stampGst: accumulator.stampGst + currentValue.stampGst
            };
          },
          {
            subtotalAmount: 0,
            totalAmount: 0,
            stampMarkupAmount: 0,
            stampGst: 0
          }
        );

        const roundToTwoDecimalPlaces = value => {
          return Number.isInteger(value) ? value : value.toFixed(2);
        };
        const roundedTotalAmountInfo = {
          subtotalAmount: roundToTwoDecimalPlaces(totalAmountInfo.subtotalAmount),
          totalAmount: roundToTwoDecimalPlaces(totalAmountInfo.totalAmount),
          stampMarkupAmount: roundToTwoDecimalPlaces(totalAmountInfo.stampMarkupAmount),
          stampGst: roundToTwoDecimalPlaces(totalAmountInfo.stampGst)
        };

        setTotaAmountInfo(roundedTotalAmountInfo);
      } catch (error) {
        return error;
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleAddDenomination = async () => {
    const id = nanoid(5);
    const newUserData = {
      id,
      denominationAmount: '',
      denominationQty: '',
      denominationValue: ''
    };
    setUserData([...userData, newUserData]);
  };
  const handleRemoveItem = async elIndex => {
    if (userData?.length > 1) {
      const newData = userData.filter((el, index) => index !== elIndex);
      setUserData(newData);
      await updateGstMarkUpTotal(newData);
    }
  };
  const handleTabChange = (event, newValue) => {
    if (newValue === 1) {
      setError({});
    }
    setTabValue(newValue);
  };
  const handleChange = async (updatedData, signal) => {
    //const totalDenominationAmount = updatedData.reduce((a, v) => (a = a + v.denominationValue), 0);
    await updateGstMarkUpTotal(updatedData, signal);
  };

  const fetchArticleCodes = async id => {
    try {
      const response = await getArticleCodes(id);
      if (response?.status === 200) {
        setArticleCodes(response?.data?.articleCodeData);
      }
    } catch (err) {
      return err;
    }
  };

  function handleAddValue() {
    let totalAmount = userData.reduce((a, v) => (a = a + v.denominationValue), 0);
    return totalAmount;
  }
  const handleInputState = (value, name) => {
    setError(prevState => ({
      ...prevState,
      [name]: ''
    }));
    setSelectState(value);
  };
  const handleInput = (value, name) => {
    setError(prevState => ({
      ...prevState,
      [name]: ''
    }));
    if (name === 'name') {
      value = validateName(value);
    }
    if (name === 'dist') {
      value = validateName(value);
    }
    if (name === 'city') {
      value = validateName(value);
    }
    if (name === 'pincode' && !POSTAL_CODE.test(value)) {
      value = validatePincode(value);
      setError(prevState => ({
        ...prevState,
        pincode: 'Invalid Pincode format'
      }));
    }
    if (tabValue === 0) {
      setFirstPartyData({ ...firstPartyData, [name]: value });
    } else {
      setSecondPartyData({ ...secondPartyData, [name]: value });
    }
    return value;
  };

  const handleClickProceed = () => {
    let errorNext = true;

    userData.map(el => {
      if (el?.denominationAmount === '' || el?.denominationAmount === 0) {
        errorNext = false;
        setUserDataError(prevState => ({
          ...prevState,
          denominationAmount: 'Denomination Amount is required'
        }));
      }
      if (el?.denominationQty === '' || el?.denominationQty === 0) {
        errorNext = false;
        setUserDataError(prevState => ({
          ...prevState,
          denominationQty: 'Denomination Qty is required'
        }));
      }
    });
    if (selectState === '') {
      errorNext = false;
      setError(prevState => ({
        ...prevState,
        selectState: 'State is required'
      }));
    }
    if (firstPartyData?.name?.length < 3) {
      errorNext = false;
      setError(prevState => ({
        ...prevState,
        name: 'Name must be atleast 3 characters'
      }));
    }
    if (firstPartyData?.address === '') {
      errorNext = false;
      setError(prevState => ({
        ...prevState,
        address: 'Address is required'
      }));
    }
    if (firstPartyData?.pincode.length !== 6) {
      errorNext = false;
      setError(prevState => ({
        ...prevState,
        pincode: 'Enter Valid Pincode'
      }));
    }

    if (errorNext && isValidPincode) {
      setOpenAlertModel(true);
    }
  };
  const handleOnClose = () => {
    onClose();
    setError({});
    setUserDataError({});
    setArticleCodes([]);
    setArticleCode('');
    setFirstPartyData({
      name: '',
      address: '',
      state: '',
      dist: '',
      city: '',
      pincode: ''
    });
    setSecondPartyData({
      name: '',
      address: '',
      state: '',
      dist: '',
      city: '',
      pincode: ''
    });
    setUserData([
      {
        id: '',
        denominationAmount: '',
        denominationQty: '',
        denominationValue: ''
      }
    ]);
    setSelectState('');
  };
  const handleClickProceedApi = async () => {
    if (!articleCode) {
      showToast('error', 'please select a article code');
      return;
    }
    setIsLoading(true);
    let totalAmount = handleAddValue();
    const newArrayWithoutId = userData.map(({ id, ...rest }) => rest);
    let payload = {
      stateId: selectState,
      firstPartyName: firstPartyData.name,
      secondPartyName: secondPartyData.name,
      firstPartyAddress: firstPartyData.address,
      secondPartyAddress: secondPartyData.address,
      firstPartyState: firstPartyData.state,
      secondPartyState: secondPartyData.state,
      firstPartyDistrict: firstPartyData.dist,
      secondPartyDistrict: secondPartyData.dist,
      firstPartyCity: firstPartyData.city,
      secondPartyCity: secondPartyData.city,
      firstPartyPincode: firstPartyData.pincode,
      secondPartyPincode: secondPartyData.pincode,
      stampAmount: totalAmount,
      orders: newArrayWithoutId,
      articleCode: articleCode
    };
    try {
      const response = await DigitalStampOrderDetails(payload);
      if (response.status === 200) {
        setIsLoading(false);
        dispatch(updateSuccessStatus(true));
        setOpenAlertModel(false);
        handleOnClose();
      } else if (response.status === 422) {
        setIsLoading(false);
        dispatch(updateSuccessStatus(false));
        setOpenAlertModel(false);
        showToast('error', response?.message ? response.message : response?.error);
      } else if (response.status === 500) {
        setIsLoading(false);
        dispatch(updateSuccessStatus(false));
        setOpenAlertModel(false);
        showToast('error', response?.message ? response.message : response?.error);
      }
    } catch {
      setIsLoading(false);
    }
  };
  const renderParty = data => {
    return (
      <>
        <div className='margin-bottom-top'>
          <TextField
            value={data?.name}
            style={{ marginBottom: 20 }}
            labelClassName={'medium6'}
            placeholder={'Name'}
            width={'100%'}
            removeImageLeftBorder={true}
            type={'text'}
            borderColor={'#ECF0E5'}
            name={'name'}
            handleInput={handleInput}
            required
            error={error.name || ''}
          />
        </div>
        <div className='margin-bottom'>
          <TextField
            textArea={true}
            value={data?.address}
            style={{ marginBottom: 20 }}
            labelClassName={'medium6'}
            placeholder={'Flat, House no., Building, apartment, Area, Street, Sector etc.'}
            width={'100%'}
            removeImageLeftBorder={true}
            type={'text'}
            borderColor={'#ECF0E5'}
            name={'address'}
            handleInput={handleInput}
            required
            error={error.address || ''}
          />
        </div>
        <div className='stamp-field-space-between'>
          <div style={{ width: '48%' }}>
            <TextField
              value={data?.pincode}
              style={{ marginBottom: 20 }}
              labelClassName={'medium6'}
              placeholder={'Pincode'}
              width={'100%'}
              removeImageLeftBorder={true}
              type={'text'}
              borderColor={'#ECF0E5'}
              name={'pincode'}
              handleInput={handleInput}
              maxLength={6}
              required
              error={error.pincode || ''}
            />
          </div>
          <div style={{ width: '48%' }}>
            <TextField
              value={data?.city}
              style={{ marginBottom: 20 }}
              disabled={true}
              labelClassName={'medium6'}
              placeholder={'City'}
              width={'100%'}
              removeImageLeftBorder={true}
              type={'text'}
              borderColor={'#ECF0E5'}
              name={'city'}
              handleInput={handleInput}
              maxLength={10}
              required
              error={error.city || ''}
            />
          </div>
        </div>
        <div className='stamp-field-space-between'>
          <div style={{ width: '48%' }}>
            <TextField
              value={data?.dist}
              style={{ marginBottom: 20 }}
              disabled={true}
              labelClassName={'medium6'}
              placeholder={'District'}
              width={'100%'}
              removeImageLeftBorder={true}
              type={'text'}
              borderColor={'#ECF0E5'}
              name={'dist'}
              handleInput={handleInput}
              maxLength={10}
              required
              error={error.dist || ''}
            />
          </div>
          <div style={{ width: '48%' }}>
            <TextField
              value={data?.state}
              style={{ marginBottom: 20 }}
              disabled={true}
              labelClassName={'medium6'}
              placeholder={'State'}
              width={'100%'}
              removeImageLeftBorder={true}
              type={'text'}
              borderColor={'#ECF0E5'}
              name={'dist'}
              handleInput={handleInput}
              maxLength={10}
              required
              error={error.state || ''}
            />
          </div>
        </div>
      </>
    );
  };
  return (
    <>
      <GeneralModal
        showCloseIcon={true}
        open={open}
        onClose={() => handleOnClose()}
        btn1Text={'Cancel'}
        btn2Text={'Proceed'}
        btn1OnClick={() => handleOnClose()}
        btn2OnClick={handleClickProceed}
        //   btn2Disabled={isAddButtonDisabled}
        width={isMobile ? '90%' : '450px'}
        maxHeight={isMobile ? '620px' : '700px'}
        padding={isMobile ? '20px' : '32px'}
        genText={'Digital Stamp Order Details'}
      >
        <div className='stamp-scroll-height'>
          <div className='margin-bottom-top'>
            <DropDown
              placeholder={'Select state'}
              width={'100%'}
              height={'41px'}
              borderColor={'#ECF0E5'}
              name={'selectState'}
              className={'medium5'}
              dropdownValue={stampStateValue}
              dropDownSelected={selectState}
              handleChange={e => {
                const value = e.target.value;
                fetchArticleCodes(value);
                handleInputState(value, 'selectState');
              }}
            />
            <div className='medium8' style={{ color: '#E96666' }}>
              {error.selectState || ''}
            </div>
          </div>

          {userProfileValue?.department && (
            <div className='margin-bottom'>
              <TextField
                value={userProfileValue?.department}
                style={{ marginBottom: 20 }}
                labelClassName={'medium6'}
                placeholder={'Department'}
                width={'100%'}
                removeImageLeftBorder={true}
                type={'text'}
                borderColor={'#ECF0E5'}
                name={'department'}
                required
                disabled={true}
                isColorChange={true}
                customStyle={{ opacity: 1 }}
              />
            </div>
          )}

          <div className='stamp-field-space-between'>
            {userProfileValue?.branch?.branchName && (
              <div style={{ width: '48%' }}>
                <TextField
                  value={userProfileValue?.branch?.branchName}
                  style={{ marginBottom: 20 }}
                  labelClassName={'medium6'}
                  placeholder={'Branch Name'}
                  width={'100%'}
                  removeImageLeftBorder={true}
                  type={'text'}
                  borderColor={'#ECF0E5'}
                  name={'Name'}
                  required
                  disabled={true}
                  isColorChange={true}
                  customStyle={{ opacity: 1 }}
                />
              </div>
            )}
            {userProfileValue?.branch?.branchId && (
              <div style={{ width: '48%' }}>
                <TextField
                  value={userProfileValue?.branch?.branchId}
                  style={{ marginBottom: 20 }}
                  labelClassName={'medium6'}
                  placeholder={'Branch ID '}
                  width={'100%'}
                  removeImageLeftBorder={true}
                  type={'text'}
                  borderColor={'#ECF0E5'}
                  name={'Name'}
                  required
                  disabled={true}
                  isColorChange={true}
                  customStyle={{ opacity: 1 }}
                />
              </div>
            )}
          </div>

          <DropDown
            className={'medium6'}
            width={'100%'}
            height={'40px'}
            placeholder={'Select Article Code'}
            dropdownValue={articleCodes}
            name={'digitalStampStateId'}
            handleChange={e => {
              const value = e.target.value;
              setArticleCode(value);
            }}
            disabled={!articleCodes?.length}
            dropDownSelected={articleCode}
          />

          <div style={{ margin: '16px 0px' }}>
            {userData &&
              userData.map((val, i) => (
                <DigitalStampDenomination
                  key={val.id}
                  data={userData}
                  stampData={val}
                  articleCodes={articleCodes}
                  index={i}
                  handleRemoveItem={handleRemoveItem}
                  setData={setUserData}
                  handleChange={handleChange}
                  id={val.id}
                  userDataError={userDataError}
                  setUserDataError={setUserDataError}
                />
              ))}
          </div>
          <PrimaryButton
            value={'Add more'}
            width={'100%'}
            onClick={handleAddDenomination}
            backgroundColor={'#B7D423'}
          />
          <div className='stamp-dotted-border' />
          <div className='semiBold9 stamp-test-space' style={{ marginTop: '5px', color: 'gray' }}>
            <div>Subtotal</div>
            <div>₹{totalAmountInfo.subtotalAmount}</div>
          </div>
          <div className='semiBold9 stamp-test-space' style={{ marginTop: '5px', color: 'gray' }}>
            <div>Markup amount</div>
            <div>₹{totalAmountInfo.stampMarkupAmount}</div>
          </div>
          <div className='semiBold9 stamp-test-space' style={{ marginTop: '5px', color: 'gray' }}>
            <div>GST</div>
            <div>₹{totalAmountInfo.stampGst}</div>
          </div>
          <div className='semiBold9 stamp-test-space' style={{ marginTop: '5px' }}>
            <div>Total</div>
            <div>₹{totalAmountInfo.totalAmount}</div>
          </div>
          <Tabs value={tabValue} onChange={handleTabChange}>
            <Tab value={0} label={'First Party*'} className='text-transform-capitalise' />
            <Tab value={1} label={'Second Party'} className='text-transform-capitalise' />
          </Tabs>
          {tabValue === 0 && renderParty(firstPartyData)}
          {tabValue === 1 && renderParty(secondPartyData)}
        </div>
      </GeneralModal>
      <GeneralModal
        width={isMobile ? '318px' : '400px'}
        minHeight={'250px'}
        padding={isMobile ? '20px' : '32px'}
        maxHeight={'700px'}
        genText={'Proceed?'}
        open={openAlertModel}
        onClose={() => setOpenAlertModel(false)}
        btn1Text={'No, Cancel'}
        btn2Text={'Yes, Proceed'}
        btn1OnClick={() => setOpenAlertModel(false)}
        btn2OnClick={handleClickProceedApi}
      >
        <div>
          <div>Are you sure you want to Proceed with order?</div>
        </div>
      </GeneralModal>
      {isLoading && <Loading open={isLoading} onClose={() => setIsLoading(false)} />}
    </>
  );
}
